import { Component, OnInit, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { DirectionsService } from 'src/app/services/directions.service';
import { url } from 'inspector';
import { LatLng } from '@google/maps';



/**
 * Pàgina per configurar la impressió d'una ruta
 */
@Component({
  selector: 'app-print-directions',
  templateUrl: './print-directions.component.html',
  styleUrls: ['./print-directions.component.css']
})
export class PrintDirectionsComponent implements OnInit {

  /**
   * Constructor del component
   * @param {DirectionsService} directionsService Servei de càlcul de rutes de l'aplicació
   * @param {ChangeDetectorRef} cdRef Detecta els canvis en la plantilla del component
   */
  constructor(private directionsService: DirectionsService, public cdRef:ChangeDetectorRef) { }

  /**
   * Mapa on es dibuixa la ruta
   */
  map: google.maps.Map; 

  /**
   * Ruta per imprimir
   */
  route: google.maps.DirectionsRoute = this.directionsService.getActiveRoute();

  /**
   * URL de l'API de Google Maps Static Map Service
   */
  staticMapBaseUrl: string = 'https://maps.googleapis.com/maps/api/staticmap?';

  /**
   * Indica si es vol mostrar o no el mapa amb la ruta
   */
  showMap: boolean = true;

  /**
   * Passos de la ruta que tenen el mini-mapa visible
   */
  stepVisible: boolean[] = [];

  /**
   * @ignore
   */
  urlImg: string = "assets/img/";

  /**
   * @ignore
   */
  iconNames = ["routeIconA.svg","routeIconB.svg","routeIconC.svg","routeIconD.svg","routeIconE.svg","routeIconF.svg","routeIconG.svg","routeIconH.svg"]
  
  /**
   * Dades relacionades amb el càlcul de rutes de Inrix
   */
  inrixData;
  
  /**
   * Indica si el càlcul de la ruta s'ha fet amb el servei d'Inrix o no
   */
  inrixFlag : boolean = false;

  /**
   * Centre del mapa
   */
  center = new google.maps.LatLng(40.38937, -3.511634); // Centre del mapa
   
  /**
   * Opcions per la creació del mapa
   */
  mapProperties: google.maps.MapOptions = {
    zoom: 7,
    center: this.center,   
    gestureHandling: 'greedy'
  };

  /**
   * Donat un pas d'una ruta, retorna una url que conté un mapa estàtic amb el pas dibuixat
   * @param {google.maps.DirectionsStep} step Pas d'una ruta
   * @returns {string} url que conté un mapa estàtic amb el pas dibuixat
   */
  getStaticMapUrl(step: google.maps.DirectionsStep): string{
    this.stepVisible.push(false);
    var size = 'size=200x200';
    var scale = '&scale=200';
    var markers = '&markers=color:0xCC3232%7Clabel:A%7C' + step.start_location.lat() + ',' + step.start_location.lng()
                  + '&markers=color:0x2DC937%7Clabel:B%7C' + step.end_location.lat() + ',' + step.end_location.lng();
    var pathStyle = '&path=color:0xFFD401FF%7Cweight:5';
    step.path.forEach(stepLocation => {
      pathStyle += '%7C' + stepLocation.lat().toPrecision(8) + ',' + stepLocation.lng().toPrecision(8);

    })
    var key = "&key=AIzaSyCA1dCbPTgK0I-8FCWpAk2Qs4U6TGcZbG0";
    return this.staticMapBaseUrl + size + scale + markers + pathStyle + key;
  }

  /**
   * Retorna la distància total calculada pel servei de rutes
   * @returns {string} Distància de la ruta en format text
   */
  getDistance(): string {
    return this.directionsService.calcDistance(this.route);
  }
  
  /**
   * Retorna la duració total calculada pel servei de rutes
   * @returns {string} Duració de la ruta en format text
   */
  getDuration(): string {
    return this.directionsService.calcDuration(this.route);
  }

  /**
   * Retorna el consum de combuscitble total calculat pel servei de rutes
   * @returns {number} Distància de la ruta en format text
   */
  getFuel(): number {
    return this.directionsService.calcFuel(this.route);
  }

  /**
   * Activa o desactiva el mapa que mostra la ruta sencera
   */
  toggleMap(): void{
    this.showMap = !this.showMap;
  }

  /**
   * activa o desactiva el minimapa d'aquest pas
   * @param {number} index indica l'índex de l'array de passos per aquest pas
   */
  toggleStepMap(index: number): void{
    this.stepVisible[index] = !this.stepVisible[index];
  }

  /**
   * Imprimeix la pàgina
   */
  print(): void{
    window.print();
  }


  /**
   * Inicialitza el component creant el mapa, pintant la ruta i subscribint-se als serveis de rutes
   */
  ngOnInit() {
    var mapElement = document.getElementById('mapPrint'); //Element HTML que contindrà el mapa
    this.map = new google.maps.Map(mapElement, this.mapProperties);
    this.directionsService.setMap(this.map);
    this.directionsService.getInrix().subscribe( data => {
      this.inrixData = data;
      ;
    })
    this.directionsService.getInrixFlag().subscribe( value => {
      this.inrixFlag = value;
      if(this.inrixFlag){
        this.map.fitBounds(this.inrixData.bounds);
        this.directionsService.drawInrixRoute();
      } 
      
    })
    
  }


}
